var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverheadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4180_5746)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87525 21.293L2.83984 26.6333H6.87525V21.293Z",
    fill: "#BF642B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8289 37.6673C48.5149 37.4598 50.0659 38.5983 50.3577 40.2651L50.6231 41.7726H53.9035V35.3203H16.8926V41.7726H20.173L20.4359 40.2651C20.7278 38.5983 22.2812 37.4598 23.9672 37.6673C24.8138 37.7734 25.5688 38.2003 26.0898 38.8733C26.6084 39.539 26.8352 40.364 26.729 41.201L26.6591 41.7726H44.137L44.0646 41.201C43.9585 40.364 44.1876 39.539 44.7038 38.8733C45.2272 38.2003 45.9822 37.7734 46.8289 37.6673Z",
    fill: "#BF642B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3602 19.0653H64.0717V7.56934H6.72461V19.0653H63.3602ZM55.0988 10.7943C56.5026 10.7943 57.6411 11.9231 57.6411 13.3173C57.6411 14.7115 56.5026 15.8403 55.0988 15.8403C53.695 15.8403 52.5565 14.7115 52.5565 13.3173C52.5565 11.9231 53.695 10.7943 55.0988 10.7943ZM15.6975 10.7943C17.1014 10.7943 18.2399 11.9231 18.2399 13.3173C18.2399 14.7115 17.1014 15.8403 15.6975 15.8403C14.2937 15.8403 13.1552 14.7115 13.1552 13.3173C13.1552 11.9231 14.2937 10.7943 15.6975 10.7943Z",
    fill: "#BF642B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0129 42.8921C30.6945 43.7821 30.504 44.8434 30.4316 46.1218C30.3617 47.3592 30.463 48.5556 30.7331 49.6796C30.9068 50.4033 31.119 50.9822 31.3458 51.3536C31.956 52.3522 33.6155 53.7561 35.3981 53.7561C37.1806 53.7561 38.8401 52.3522 39.4479 51.3536C39.6771 50.9822 39.8869 50.4033 40.0606 49.6796C40.3308 48.5556 40.4321 47.3592 40.3621 46.1218C40.2898 44.8434 40.0992 43.7821 39.7808 42.8896H31.0129V42.8921Z",
    fill: "#BF642B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4180_5746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 50,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8477 0H59.6295V6.96367H10.8477V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4180_5746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1797 0H59.6311V6.44989H11.1797V0Z",
    fill: "#BF642B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6319 20.1807H45.0898L56.2795 24.0448L61.6319 20.1807Z",
    fill: "#BF642B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 20.1807V26.6306H62.797V20.7161L56.6944 25.1206C56.598 25.1905 56.4822 25.2267 56.3664 25.2267C56.3061 25.2267 56.2434 25.2171 56.1831 25.1978L41.6551 20.1807H7.99219Z",
    fill: "#BF642B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.375 28.8613V34.2017H65.4128L61.375 28.8613Z",
    fill: "#BF642B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4180_5746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 38,
    width: 32,
    height: 31
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4883 38.4541H50.9804V68.236H19.4883V38.4541Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4180_5746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2511 40.457C49.063 39.3788 48.0571 38.6407 46.9621 38.7782C46.4121 38.8457 45.9225 39.1231 45.5824 39.5597C45.2495 39.989 45.1024 40.5221 45.1699 41.06L45.8284 46.2797C46.0286 47.8645 45.001 49.3527 43.4404 49.7411L41.0428 50.3369C40.8595 50.9978 40.6448 51.5357 40.3988 51.9361C39.7065 53.0721 37.7335 54.874 35.3937 54.874C33.0516 54.874 31.081 53.0721 30.3863 51.9361C30.1427 51.5357 29.928 50.9978 29.7447 50.3369L27.3446 49.7411C25.784 49.3527 24.7589 47.8645 24.9591 46.2797L25.6152 41.06C25.6827 40.5221 25.5356 39.989 25.2027 39.5597C24.865 39.1231 24.3754 38.8457 23.8254 38.7782C22.7303 38.6407 21.7245 39.3788 21.534 40.457L20.0819 48.7545C19.7297 50.759 20.7259 52.72 22.5615 53.6317L26.65 55.6579C27.6727 56.1668 28.3457 57.1871 28.406 58.3232L28.9342 68.2634H41.8533L42.3791 58.3232C42.4394 57.1871 43.1124 56.1668 44.1375 55.6579L48.2236 53.6293C50.0592 52.72 51.0578 50.759 50.7056 48.7545L49.2511 40.457Z",
    fill: "#BF642B"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2533 27.7529H10.5332V34.2028H60.2533V27.7529Z",
    fill: "#BF642B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2375 58.173C45.9263 58.1537 45.6634 58.3877 45.6417 58.6964L45.4367 61.8008C45.4174 62.1095 45.6513 62.3748 45.9601 62.3965C45.9721 62.3965 45.9842 62.3965 45.9963 62.3965C46.2881 62.3965 46.5342 62.1698 46.5535 61.8755L46.7585 58.7688C46.7802 58.46 46.5462 58.1947 46.2375 58.173Z",
    fill: "#BF642B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.874 63.8149C45.5653 63.7932 45.2999 64.0271 45.2782 64.3359L45.0756 67.4426C45.0539 67.7514 45.2879 68.0167 45.5966 68.0384C45.6087 68.0384 45.6207 68.0384 45.6328 68.0384C45.9271 68.0384 46.1731 67.8117 46.1924 67.515L46.395 64.4107C46.4167 64.1019 46.1828 63.8342 45.874 63.8149Z",
    fill: "#BF642B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8015 52.3539C53.541 52.1899 53.196 52.2695 53.0296 52.53L51.3725 55.1737C51.2085 55.4342 51.2881 55.7791 51.5486 55.9431C51.6426 56.001 51.744 56.0299 51.8453 56.0299C52.0334 56.0299 52.2143 55.9359 52.3204 55.767L53.9775 53.1258C54.144 52.8629 54.0644 52.518 53.8015 52.3539Z",
    fill: "#BF642B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7946 62.3965C24.8066 62.3965 24.8211 62.3965 24.8332 62.3965C25.1419 62.3748 25.3759 62.1095 25.3542 61.8008L25.1492 58.6964C25.1299 58.3877 24.8645 58.1537 24.5558 58.173C24.247 58.1947 24.0131 58.46 24.0324 58.7688L24.2374 61.8755C24.2567 62.1698 24.5027 62.3965 24.7946 62.3965Z",
    fill: "#BF642B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9206 63.8149C24.6118 63.8342 24.3803 64.1019 24.3996 64.4107L24.6046 67.515C24.6239 67.8117 24.8699 68.0384 25.1618 68.0384C25.1738 68.0384 25.1859 68.0384 25.2004 68.036C25.5067 68.0167 25.7407 67.7514 25.7214 67.4426L25.5164 64.3359C25.4971 64.0271 25.2293 63.7932 24.9206 63.8149Z",
    fill: "#BF642B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7658 52.53C17.6017 52.2695 17.2568 52.1899 16.9939 52.3539C16.7334 52.518 16.6538 52.8629 16.8178 53.1258L18.4749 55.767C18.581 55.9359 18.7644 56.0299 18.9501 56.0299C19.0514 56.0299 19.1551 56.001 19.2468 55.9431C19.5097 55.7791 19.5869 55.4342 19.4229 55.1737L17.7658 52.53Z",
    fill: "#BF642B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6421 39.9942C64.7087 39.3791 63.7052 38.8823 62.6487 38.5156L60.2246 42.1265C61.2666 42.5124 62.2628 43.0166 63.1891 43.6292C64.1201 44.2467 64.974 44.9655 65.7338 45.776L68.1603 42.1627C67.4174 41.3378 66.5708 40.6093 65.6421 39.9942Z",
    fill: "#BF642B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2162 39.9911L7.91062 36.6504C6.81553 37.4753 5.83141 38.4377 4.98235 39.5159C4.1333 40.5917 3.43139 41.7688 2.88867 43.0207L7.19664 46.3662C7.76107 45.1216 8.47263 43.9517 9.32168 42.876C10.1683 41.8002 11.1404 40.8329 12.2162 39.9911Z",
    fill: "#BF642B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9941 48.8108C59.4279 52.1129 61.8689 53.3648 63.0219 52.8341C63.7407 52.5037 64.2448 51.399 64.0205 50.6464C63.6635 49.4379 61.1043 48.4466 56.9941 48.8108Z",
    fill: "#BF642B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08929 49.8235C8.9108 50.3711 9.2702 51.2177 9.7888 51.4758C10.6475 51.8979 12.5193 51.0006 14.4706 48.5596C13.9545 48.5065 13.4648 48.4824 13.0089 48.4824C10.7946 48.4824 9.33774 49.0661 9.08929 49.8235Z",
    fill: "#BF642B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4180_5746",
    x: 0.375032,
    y: 0,
    width: 70.2499,
    height: 73.166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.46481
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23241
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4180_5746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4180_5746",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverheadsIcon);
export default __webpack_public_path__ + "static/media/overheads_icon.27e7efff9f2a69002e2aace11af02351.svg";
export { ForwardRef as ReactComponent };